import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalizationPipe, LocalizationService } from '@shared/modules/localization';

@Component({
  selector: 'pkp-mourning-banner',
  standalone: true,
  imports: [LocalizationPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: var(--mourning-banner-height);
        padding: 0 24px;
        background: #000;
        color: #fff;
        line-height: 1.25;
        overflow: hidden;
      }
      .mourning-banner__date {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-transform: uppercase;
      }
      .mourning-banner__title {
        font-size: 14px;
      }
      .mourning-banner__date,
      .mourning-banner__title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      @media (max-width: 767px) {
        :host {
          padding: 0 16px;
        }
        .mourning-banner__date {
          font-size: 14px;
        }
        .mourning-banner__title {
          font-size: 12px;
        }
      }
    `,
  ],
  template: `
    <span class="mourning-banner__date">{{ 'MOURNING_BANNER_DATE' | localization }}</span>
    <span class="mourning-banner__title">{{ 'MOURNING_BANNER_TITLE' | localization }}</span>
  `,
  host: { role: 'note' },
})
export class MourningBannerComponent {
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    inject(LocalizationService)
      .onLangChanged.pipe(takeUntilDestroyed())
      .subscribe(() => this.cdr.markForCheck());
  }
}
